module.exports = __webpack_public_path__ + "04_long_grey.d712cd2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/04_long_grey.png
// module id = /WeH
// module chunks = 0